import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=0df95c2c&scoped=true"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=0df95c2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df95c2c",
  null
  
)

export default component.exports